// extracted by mini-css-extract-plugin
export default {"root":"OfferPaymentLink__root--BjvouS","dashboardlink":"OfferPaymentLink__dashboardlink--69Lwfq"};